import React from 'react'
import { View } from 'react-native'

import { B2, SH3 } from '@zet/design-system/typography'

interface Props {
  label: string
  value?: string | boolean | number
}

const Field: React.FC<Props> = (props) => {
  const { label, value } = props

  return (
    <View>
      <B2>{label}</B2>
      <SH3 className="mt-1">{value || '-'}</SH3>
    </View>
  )
}

export default Field
